<app-payment-panel-adyen-generic
  type="paywithgoogle"
  [isPayButtonVisible]="false"
  [clientKey]="clientKey"
  [googlePayMerchantName]="googlePayMerchantName"
  [googlePayMerchantId]="googlePayMerchantId"
  [googlePayGatewayMerchantId]="googlePayGatewayMerchantId"
  [paymentMethodCbAvailable]="paymentMethodCbAvailable"
  [paymentMethodPaypalAvailable]="paymentMethodPaypalAvailable"
  [paymentMethodGooglePayAvailable]="paymentMethodGooglePayAvailable"
  [paymentMethodApplePayAvailable]="paymentMethodApplePayAvailable"
  paymentMethodHandle="ADYEN_GOOGLE_PAY"
>
  <app-payment-panel-button-skeleton loadingState></app-payment-panel-button-skeleton>
</app-payment-panel-adyen-generic>
